import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './stores'
import '@/plugins/dayjs.plugin'

Vue.config.productionTip = false

const dsUrl = new URL(window.location.href)
dsUrl.searchParams.set('ds', crypto.randomUUID())
window.history.replaceState({}, '', dsUrl)

new Vue({
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
